import { Questionnaire } from "@/types/questionnaire/models"

export interface PdfAnswerCounts {
  totalQuestions: number
  answeredTotal: number
  sectionTotals: Record<string, number>
  sectionAnswered: Record<string, number>
}

export function getPdfAnswerCounts(
  questionnaire: Questionnaire | undefined,
): PdfAnswerCounts {
  const empty: PdfAnswerCounts = {
    totalQuestions: 0,
    answeredTotal: 0,
    sectionTotals: {},
    sectionAnswered: {},
  }

  if (!questionnaire) return empty

  const counts: PdfAnswerCounts = {
    totalQuestions: 0,
    answeredTotal: 0,
    sectionTotals: {},
    sectionAnswered: {},
  }

  questionnaire.sections.forEach((section) => {
    const total = section.responsePairs.length
    counts.totalQuestions += total
    counts.sectionTotals[section.id] = total

    let answered = 0
    section.responsePairs.forEach((pair) => {
      const text = pair.response
      if (typeof text === "string" && text.trim().length > 0) {
        answered += 1
      }
    })

    counts.sectionAnswered[section.id] = answered
    counts.answeredTotal += answered
  })

  return counts
}
